import { OptionType } from '@evinced-private/ui-common';

import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';

import {
	buildLabelsSearchValues,
	labelsSearchFields,
	testsSearchFields
} from '../../Tests/helpers/buildVariables';
import { UsageDataQueryVariables } from '../UsageData.generated';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';
const DAYS_AMOUNT_X2_FILTER_PARAM_KEY = 'daysAmountx2Filter';

export const buildUsageDataVariables = (
	testPeriod?: OptionType,
	searchValue?: string,
	labels?: OptionType[]
): UsageDataQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<UsageDataQueryVariables>({
		searchFields: testsSearchFields
	});

	variablesBuilder.addTextSearchParam(searchValue ?? '');
	if (labels?.length) {
		variablesBuilder.addTextSearchParam(buildLabelsSearchValues(labels), labelsSearchFields, true);
	}

	if (testPeriod?.value && testPeriod.value !== 'all' && typeof testPeriod.value === 'number') {
		variablesBuilder
			.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, testPeriod.value)
			.addConditionParam(DAYS_AMOUNT_X2_FILTER_PARAM_KEY, 2 * testPeriod.value);
	}
	return variablesBuilder.getVariables();
};
